export default __webpack_public_path__ + "static/section_4_details_13-ed78967e328b1e544d4cdccb9ea34cdf.png";